module.exports = __webpack_public_path__ + "img/area-limit-cancel-btn.c21c35fa.png";